import { currentScreenAndDialog, SYSDialog, TemplateResult } from "../.."
import { FocusSet } from "../../global/globalapi"
import type { DialogType } from "./sysdialogbase"
import { SYSBaseDialog } from "./sysdialogbase"

export type DialogGetParts = {
  header?: () =>
    | TemplateResult
    | TemplateResult[]
    | Promise<TemplateResult>
    | Promise<TemplateResult[]>
  title?: () => any
  body?: () =>
    | TemplateResult
    | TemplateResult[]
    | Promise<TemplateResult>
    | Promise<TemplateResult[]>
  footer?: () =>
    | TemplateResult
    | TemplateResult[]
    | Promise<TemplateResult>
    | Promise<TemplateResult[]>
  keyHandlerFn?: any
  closedCallbackFn?: any
  dismissedCallbackFn?: any
  closeOnDismiss?: boolean
  emptySpaceClickHandlerFn?: any
  type?: () => DialogType
  instance?: any
  customClass?: () => string
}

export type _DialogHolderParams = {
  dialogParts: DialogGetParts
  dialogType: SYSDialog
  instance?: any
}
export class SYSDialogHolder extends SYSBaseDialog {
  dialogHolderParams: _DialogHolderParams
  async updated() {
    let dialog = currentScreenAndDialog.dialogFocusSet.dialog
    let instance = currentScreenAndDialog.dialogFocusSet.instance
    if (dialog && dialog === this.dialog && instance === this.dialogInstance) {
      currentScreenAndDialog.dialogFocusSet.dialog = undefined
      let id = `ovl-dialog-${dialog}-${instance}`
      FocusSet(id, {
        ignoreIfAlreadySetOnScreenOrDialog: true,
      })
    }
    await super.updated()
  }

  async afterRender() {
    await super.afterRender()
  }

  async getUI() {
    let d = this.dialogHolderParams.dialogParts
    let res = this.getDialogTemplate({
      title: d.title ? d.title() : undefined,
      body: d.body ? await d.body() : undefined,
      header: d.header ? await d.header() : undefined,
      footer: d.footer ? await d.footer() : undefined,
      customClass: d.customClass ? d.customClass() : undefined,
      type: d.type ? d.type() : undefined,
      keyHandlerFn: d.keyHandlerFn,
      closeOnDismiss: d.closeOnDismiss,
      dismissHandlerFn: d.dismissedCallbackFn,
      emptySpaceClickHandlerFn: d.emptySpaceClickHandlerFn,
      closedCallbackFn: d.closedCallbackFn,
    })
    return res
  }
  async connectedCallback() {
    this.isDialogHolder = true
    this.dialog = this.dialogHolderParams.dialogType
    this.dialogInstance = this.dialogHolderParams.instance
      ? this.dialogHolderParams.instance
      : this.dialogHolderParams.dialogType

    await super.connectedCallback()
    // if (!this.dialogState.zIndex) {
    //   let dlgsCount = Object.keys(currentScreenAndDialog.dialogs).length
    //   this.dialogState.zIndex = 6 + dlgsCount
    // }
    // this.zIndex = this.dialogState.zIndex
  }
  async disconnectedCallback() {
    this.dialogHolderParams = null
    await super.disconnectedCallback()
  }
}
